module.exports = __webpack_public_path__ + "static/event-meridian-e3abbea34d7422a2f08b06b7ec113f92.jpg";